import { jwtDecode } from 'jwt-decode';
import { decode } from 'punycode';


export const isAuth = (): boolean => {
    const token = localStorage.getItem('token');
    if(token) {
        try {
            const decoded: {exp: number } = jwtDecode(token);
            return decoded.exp > Date.now() / 1000;
        } catch (error) {
            console.error("Token decoding error:", error);
            return false;
        }
    }
    return false;
};


type TokenInfo = {
    email: string,
    name: string
}

export const getRoleFromToken = (): string => {
    const token = localStorage.getItem('token');
    if(token) {
        const decoded: {role: string} = jwtDecode(token);
        return decoded.role || "";
    }
    return "";
}

export const getUsernameFromToken = (): string => {
    const token = localStorage.getItem('token');
    if(token) {
        const decoded: {username: string} = jwtDecode(token);
        return decoded.username || "";
    }
    return "";
}

export function getEmailFromToken(): string {
    const token = localStorage.getItem('token');
    if(token) {
        const decoded: {email: string } = jwtDecode(token);
        return decoded.email || "";
    }
    return "";
}


export const getNameFromToken = (): string => {
    const token = localStorage.getItem('token');
    if(token) {
        const decoded: {name: string} = jwtDecode(token);
        return decoded.name || "";
    }
    return "";
}